import React from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { isEmpty } from "lodash";
import { isDownloadDisabled } from "modules/utilities/utility";

function DownloadTransferCustomer({ customerData, setMessage }) {
  const exportCSV = () => {
    try {
      let csvRow = [];
      let rowName = [
        [encodeURIComponent("Case ID"), encodeURIComponent("Email ID")],
      ];

      for (let customer of customerData) {
        rowName.push([
          encodeURIComponent(customer.case_id),
          encodeURIComponent(customer.email),
        ]);
      }
      for (let customerRow of rowName) {
        csvRow.push(customerRow.join(","));
      }

      let csvString = csvRow.join("%0A");
      let anchorTag = document.createElement("a");
      anchorTag.href = "data:attachment/csv," + csvString;
      anchorTag.target = "_Blank";
      anchorTag.download = "transfer-customer.csv";
      document.body.appendChild(anchorTag);
      anchorTag.click();
    } catch (error) {
      console.error(error);
      setMessage("download error");
    }
  };

  return (
    <div>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        onClick={exportCSV}
        disabled={isDownloadDisabled && isEmpty(customerData)}
      >
        Download
      </Button>
    </div>
  );
}

export default DownloadTransferCustomer;
